import React from 'react';

export default ({ theme }) =>
  <div className={theme.root}>
    Findify Custom Layout
  </div>
